import {renderModalError} from "../../../utils/forms";

import {routes} from "../../app/constants/routes";

export const encodingJobProfileModalError = () => (
    renderModalError('Encoding job profile', routes.encodingJobProfile.index.path)
);
